import { useRef, useState, useEffect } from "react";

import { useMapsLibrary, useMap } from "@vis.gl/react-google-maps";
import { useContext } from "react";

import LocationContext from "../../../../locationContext";
import classes from './PlaceAutocompete.module.css';


const PlaceAutocomplete = (props) => {
    const location = useContext(LocationContext);
    const inputRef = useRef();
    const [currentLocation, setCurentLocation] = useState(null);
    const geoCoding = useMapsLibrary("geocoding");
    const placesLib = useMapsLibrary("places");
    const map = useMap();

    useEffect(() => {
        if (!geoCoding || !map || !placesLib) return;

        const geoCoder = new geoCoding.Geocoder();
        if (currentLocation != null) {
            geoCoder.geocode({ location: currentLocation })
                .then(location => {
                    const placeId = location.results[0].place_id;
                    if (placeId) {
                        const placesService = new placesLib.PlacesService(map);
                        const request = {
                            fields: ["geometry", "name", "formatted_address", "address_components"],
                            placeId: location.results[0].place_id

                        };
                        placesService.getDetails(
                            request,
                            (result, status) => {
                                if (status === 'OK') {

                                    setFieldValueHandler(result.formatted_address);
                                    setPlaceHandler(result);
                                }

                            }
                        )
                    }
                })
                .catch(e => {
                    console.log(e);
                });

        }

        const options = {
            fields: ["geometry", "name", "formatted_address", "address_components"],
        };

        const placeAutocomplete = new placesLib.Autocomplete(
            inputRef.current,
            options
        );

        placeAutocomplete.addListener("place_changed", () => {
            const place = placeAutocomplete.getPlace();
            setPlaceHandler(place);

        });
    }, [geoCoding, map, placesLib, currentLocation]);


    const setFieldValueHandler = (address) => {
        props.setValue(props.name, address);
    }

    const setPlaceHandler = (place) => {
        if (props.name === 'pickUpAddress') {
            //props.onSelectPickupPlace(place);
            location.setPickUpLocation(place)
        } else {
            //props.onSelectDropOffPlace(place);
            location.setDropoffLocation(place);
        }
    }

    const getCurrentLocationHanlder = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    if (position) {
                        const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude, };
                        setCurentLocation(userLocation);
                    }
                },
            );

        }
    }

    return (
        <div className="form-group">
            <label htmlFor={props.id}>{props.label}</label>
            <input
                type="text"
                id={props.id}
                placeholder={props.placeholder}
                className={props.errors && props.errors[props.name] ? 'invalid' : ''}
                {...props.register(props.name, { required: true })}
                ref={(el) => {
                    inputRef.current = el;
                    props.register(props.name).ref(el);
                }} />
            <span className={classes.GetCurrentLocationIcon} onClick={getCurrentLocationHanlder}>
                <i className="fa-solid fa-location-crosshairs"></i>
            </span>
        </div>
    );
}

export default PlaceAutocomplete;

/* const mapDispatchToProps = (dispatch) => {
    return {
        onSelectPickupPlace: (location) => dispatch(actions.setPickUpLocation(location)),
        onSelectDropOffPlace: (location) => dispatch(actions.setDropOffLocation(location)),
    }
};

export default connect(null, mapDispatchToProps)(PlaceAutocomplete); */

/* class PlaceAutocomplete extends Component {
    constructor(props) {
        super(props);
        this.inputRef = createRef();
    }

    state = {
        places: null,
        placeAutocomplete: null,
    }

    initializeAutocomplete = (places) => {
        const options = {
            fields: ["geometry", "name", "formatted_address", "address_components"],
        };

        const placeAutocomplete = new places.Autocomplete(
            this.inputRef.current,
            options
        );

        placeAutocomplete.addListener("place_changed", () => {
            const place = placeAutocomplete.getPlace();
            this.setPlaceHandler(place);

        });

        this.setState({ placeAutocomplete, places });
    };

    componentDidMount() {
        if (this.props.places && this.inputRef.current) {
            this.initializeAutocomplete(this.props.places);
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.places !== prevProps.places && this.inputRef.current) {
            this.initializeAutocomplete(this.props.places);
        }
    }



    setFieldValueHandler = (address) => {
        this.props.setValue(this.props.name, address);
    }

    setPlaceHandler = (place) => {
        if (this.props.name === 'pickUpAddress') {
            this.props.onSelectPickupPlace(place);
        } else {
            this.props.onSelectDropOffPlace(place);
        }
    }

    getCurrentLocationHanlder = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    if (position) {
                        const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude, };
                        const geoCoder = new this.props.geoCoding.Geocoder()
                        geoCoder.geocode({ location: userLocation })
                            .then(location => {

                                const placeId = location.results[0].place_id;
                                if (placeId) {
                                    const placesService = new this.props.places.PlacesService(this.props.map);
                                    const request = {
                                        fields: ["geometry", "name", "formatted_address", "address_components"],
                                        placeId: location.results[0].place_id

                                    };
                                    placesService.getDetails(
                                        request,
                                        (result, status) => {
                                            if (status === 'OK') {

                                                this.setFieldValueHandler(result.formatted_address);
                                                this.setPlaceHandler(result);
                                            }

                                        }
                                    )
                                }
                            })
                            .catch(e => {
                                console.log(e);
                            });
                    }
                },
            );

        }
    }

    render() {
        return (
            <div className="form-group">
                <label htmlFor={this.props.id}>{this.props.label}</label>
                <input
                    type="text"
                    id={this.props.id}
                    placeholder={this.props.placeholder}
                    className={this.props.errors && this.props.errors[this.props.name] ? 'invalid' : ''}
                    {...this.props.register(this.props.name, { required: true })}
                    ref={(el) => {
                        this.inputRef.current = el;
                        this.props.register(this.props.name).ref(el);
                    }} />
                <span className={classes.GetCurrentLocationIcon} onClick={this.getCurrentLocationHanlder}>
                    <i className="fa-solid fa-location-crosshairs"></i>
                </span>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        onSelectPickupPlace:(location)=>dispatch(actions.setPickUpLocation(location)),
        onSelectDropOffPlace: (location)=>dispatch(actions.setDropOffLocation(location)),
    }
};

export default connect(null, mapDispatchToProps)(withMapsLibrary(withMap(PlaceAutocomplete))); */